<!-- 伪评价页面 -->
<template>
  <div class="review-page">
    <title-bar-back :title="'评价'" @back="back"></title-bar-back>

    <div class="content">
      <!-- Rating -->
      <div class="rating-section">
        <div class="rating-item">
          <span class="label">描述相符</span>
          <van-rate
            v-model="score"
            :size="25"
            color="var(--primary-color)"
            void-icon="star"
            void-color="#eee"
          />
          <span class="score-text">{{ scoreText }}</span>
        </div>
      </div>

      <!-- Comment -->
      <div class="comment-section">
        <van-field
          v-model="content"
          rows="4"
          autosize
          type="textarea"
          maxlength="500"
          placeholder="宝贝满足你的期待吗？说说你的使用心得，分享给想买的他们吧"
          show-word-limit
          class="comment-input"
        />

        <!-- Uploader -->
        <!-- <div class="uploader-box">
          <van-uploader v-model="fileList" multiple :max-count="6" />
        </div> -->
      </div>

      <!-- Anonymous -->
      <div class="anonymous-section">
        <van-checkbox v-model="isAnonymous" checked-color="#ee0a24"
          >匿名评价</van-checkbox
        >
        <span class="tip">隐藏头像和昵称</span>
      </div>

      <!-- Submit -->
      <div class="submit-bar">
        <van-button color="var(--primary-color)" block round @click="onSubmit"
          >发布</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Rate, Toast } from "vant";

const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);

export default {
  name: "OrderReview",
  components: {
    TitleBarBack,
    [Rate.name]: Rate
  },
  data() {
    return {
      score: 5,
      content: "",
      fileList: [],
      isAnonymous: false
    };
  },
  computed: {
    scoreText() {
      const texts = ["非常差", "差", "一般", "好", "非常好"];
      return texts[this.score - 1] || "";
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    onSubmit() {
      Toast.success("评论成功");
      setTimeout(() => {
        this.$router.back();
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
.review-page {
  min-height: 100vh;
  background: #f7f8fa;
}
.content {
  padding: 12px;
}
.product-card {
  display: flex;
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  .product-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    margin-right: 12px;
    object-fit: cover;
  }
  .product-info {
    flex: 1;
    .product-title {
      font-size: 14px;
      color: #323233;
      line-height: 20px;
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .product-sku {
      font-size: 12px;
      color: #969799;
      background: #f7f8fa;
      padding: 2px 6px;
      border-radius: 4px;
      display: inline-block;
    }
  }
}

.rating-section {
  background: #fff;
  padding: 16px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  .rating-item {
    display: flex;
    align-items: center;
  }
  .label {
    font-size: 14px;
    color: #323233;
    margin-right: 12px;
    font-weight: bold;
  }
  .score-text {
    margin-left: 12px;
    color: #969799;
    font-size: 12px;
  }
}

.comment-section {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  .comment-input {
    padding: 0;
    margin-bottom: 12px;
    /deep/ .van-field__control {
      min-height: 80px;
    }
  }
  .uploader-box {
    margin-top: 8px;
  }
}

.anonymous-section {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 4px;
  justify-content: space-between;
  /deep/ .van-checkbox__icon {
    font-size: 16px;
  }
  /deep/ .van-checkbox__label {
    font-size: 14px;
  }
  .tip {
    color: #969799;
    font-size: 12px;
  }
}

.submit-bar {
  margin-top: 20px;
  padding: 0 12px 20px;
}
</style>
